import { useState } from 'react';

import { Location } from './Location';
import { Map } from './Map';
import { BoxContainer, RadioButtonContainer, TopButton } from './styles';

export function Licensed(): JSX.Element {
  const [radioButtomValue, setRadioButtomValue] = useState('location');

  return (
    <BoxContainer>
      <RadioButtonContainer>
        <TopButton
          type="button"
          className={radioButtomValue === 'location' ? 'selected' : ''}
          onClick={() => setRadioButtomValue('location')}
        >
          Localização
        </TopButton>
        <TopButton
          type="button"
          className={radioButtomValue === 'map' ? 'selected' : ''}
          onClick={() => setRadioButtomValue('map')}
        >
          Mapa
        </TopButton>
      </RadioButtonContainer>
      {radioButtomValue === 'location' ? <Location /> : <Map />}
    </BoxContainer>
  );
}
